import React from 'react';
import styled from '@emotion/styled';

import Button from '../../../components/Button';

interface ReactivateButtonProps {
  subscription: Subscription;
  handleReactivate: () => void;
  t: (key: string) => string;
  isLoadingReactivate: boolean;
  isPrepaidV2: boolean;
  isPrepaid: boolean;
}

const ReactivateButton = ({
  subscription,
  handleReactivate,
  isPrepaidV2,
  isPrepaid,
  t,
  isLoadingReactivate,
}: ReactivateButtonProps): React.ReactElement | null => {
  const isPaused = subscription?.SubscriptionStatus === 'PAUSED';
  const isCancelled = subscription?.SubscriptionStatus === 'CANCELLED';

  return isPaused || (isCancelled && !(isPrepaidV2 || isPrepaid)) ? (
    <CustomButton
      className="bundle-button--reactivate"
      outlined
      filled
      fullWidth
      disabled={isLoadingReactivate}
      onClick={handleReactivate}
    >
      {t('subscription.reactivate')}
    </CustomButton>
  ) : null;
};

const CustomButton = styled(Button)`
  height: 44px;
  display: flex;
  height: auto;
  justify-content: center;
  align-items: center;
  padding: 8px;
`;

export default ReactivateButton;
